/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import PropTypes from 'prop-types'
import { isMobile } from '../../utils'
import { VscAdd, VscRemove, FiPhone, IoLocationOutline } from 'react-icons/all' 
import { Container, Title, Paragraph, Link, TitleContainer, InfoContainer, PhoneAddressContainer } from './index.styled'

const ContactAddressComponent = React.memo(({ data: { id, title, link, infos } , isOpen, setOpenClose }) => {

  const height = { closed: '70px', opened: '214px'};
 
  return (
    <Container 
      height={isOpen? height.opened: height.closed} 
      borderColor={isOpen?'rgba(45, 90, 100, 1)': 'rgba(45, 90, 100, .5)'}
    >
      <TitleContainer className={isMobile() ? 'mobile' : ''} opacity={isOpen? 1: .5} onClick={() => setOpenClose(id)}>
        {isOpen ? 
          <VscRemove size={20} color={'#1D3739'} /> : 
          <VscAdd size={20} color={'#1D3739'}/> 
        }
        <Title>{title}</Title>
      </TitleContainer>
      <InfoContainer isOpen={isOpen}>
        <PhoneAddressContainer>
          <FiPhone size={22} color={'#2D5A64'} />
          <Paragraph>{infos.phone}</Paragraph>
        </PhoneAddressContainer>
        <PhoneAddressContainer className="address-phone">
          <IoLocationOutline size={22} color={'#2D5A64'} />
          <div>
            <Paragraph>{infos.address}</Paragraph>
            <Paragraph>{infos.zipcode}</Paragraph>
          </div>
        </PhoneAddressContainer>
        <Link href={link?.link_address} target="_blank">{link?.link_title}</Link>
      </InfoContainer>
    </Container>
  )
})

ContactAddressComponent.propTypes = {
  data: PropTypes.object,
  isOpen: PropTypes.any,
  setOpenClose: PropTypes.func
}

export default ContactAddressComponent
